export default __webpack_public_path__ + "img/instagram-logo.0fe9fdb6.png";